<script>
import eleCalendar from 'ele-calendar'
import 'ele-calendar/dist/vue-calendar.css'
import { getStock, setStock } from '@/api/hotel'
export default {
  components: {
    eleCalendar
  },
  props: {
    rightbox: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      stockAll: '', // 剩余间数合计
      bookedAll: '', // 已预订间数合计
      checked_in_all: '', // 正在入住间数合计
      finishAll: '', // 已入住退房间数合计
      // condition: true,
      datedef: [
        // { 'date': '2019-07-12', 'stock': '5', 'cid': null },
        // { 'date': '2019-07-13', 'stock': '6', 'cid': null }
      ],
      prop: 'date', // 对应日期字段名
      datas: {
        data: {
          hotel_id: '1',
          room_id: '1',
          date: ''
        },
        client_type: 'pc'
      },
      ruleForm: {
        client_type: 'pc',
        data: {
          room_id: '1',
          stock: '',
          type: '1',
          date: ''
        }
      },
      rules: {
        data: {
          stock: [
            { required: true, message: this.$t('hotel.enterStock'), trigger: 'blur' },
            { type: 'number', message: this.$t('hotel.enterNumber'), trigger: 'blur' }
          ]
        }
      },
      loading: true,
      today: ''
    }
  },
  mounted() {
    let now = new Date()
    this.today =
      now.getFullYear() +
      '-' +
      (now.getMonth() + 1 > 9 ? now.getMonth() + 1 : '0' + (now.getMonth() + 1)) +
      '-' +
      (now.getDate() > 9 ? now.getDate() : '0' + now.getDate())
    now = now.getFullYear() + '-' + (now.getMonth() + 1 > 9 ? now.getMonth() + 1 : '0' + (now.getMonth() + 1)) + '-01'
    this.datas.data.date = now
    this.getList()
  },
  methods: {
    /* 提交按钮 */
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const that = this
          /* 修改库存 */
          if (formName === 'ruleForm') {
            // console.log(this.ruleForm)
            setStock(this.ruleForm)
              .then(res => {
                that.getList()
                that.resetForm(formName)
                that.$message({
                  type: 'success',
                  message: res.message
                })
              })
              .catch(() => {
                // console.log(111)
              })
          }
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    /* 重置按钮 */
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    /* 选中的日期数组 */
    clickpick(val, selectDom) {
      // console.log(val, selectDom)
      this.ruleForm.data.date = val
    },
    /** 切换日历年、月 */
    dateChange(data) {
      let newDate = data.substring(0, 8) + '01'
      this.datas.data.date = newDate
      this.loading = true
      this.getList()
    },
    getList() {
      const that = this
      // console.log(this.datas)
      getStock(this.datas)
        .then(res => {
          that.datedef = res.data
          if (res.data[res.data.length - 1] >= that.today) {
            that.stockAll = res.all.total_stock
            that.bookedAll = res.all.total_booked
          }
          that.checked_in_all = res.all.total_checked_in
          that.finishAll = res.all.total_finish
          this.loading = false
          // console.log(234, that.stockAll,that.bookedAll,that.finishAll,that.checked_in_all)
        })
        .catch(() => {
          // console.log(111)
          this.loading = false
        })
    },
    renderContent(h, parmas) {
      const loop = data => {
        if (data.defvalue.value) {
          // 有返回数据时
          let _stock = data.defvalue.value.stock // 剩余库存
          let _booked = data.defvalue.value.booked // 预定房间数
          let _checked_in = data.defvalue.value.checked_in // 已入住
          let _finish = data.defvalue.value.finish // 已入住退房
          // let _reserved = data.defvalue.value.reserved // 剩余间数
          let txt1 = null // 已订满, 剩余XX间, 未设置
          let txt2 = null // 已预订XX间
          let txt3 = null
          if (_stock == 0 && _booked == 0 && _checked_in == 0 && _finish == 0) { // if (_stock == 0 && _reserved == 0) {
            txt1 = <Span>{this.$t('hotel.noSet')}</Span> // 未设置
          } else {
            // 酒店以往数据,剩余房间隐藏
            if (data.defvalue.value.date >= this.today) {
              switch (_stock) {
                case 0: // 已订满
                  txt1 = <Span style='color:red'>{this.$t('hotel.fullyBooked')}</Span>
                  break
                default:
                  // 剩余XX间
                  txt1 = (
                    <Span class='green'>
                      {this.$t('hotel.surplus')} {data.defvalue.value.stock} {this.$t('hotel.room')}
                    </Span>
                  )
              }
              if (_booked) {
                txt2 = `${this.$t('hotel.reserve')} ${data.defvalue.value.booked} ${this.$t(
                  'hotel.room'
                )}` // 已预订XX间
              }
            } else {
              if (_finish) {
                txt3 = `${this.$t('hotel.finished')} ${data.defvalue.value.finish} ${this.$t(
                  'hotel.room'
                )}` // 已入住离店
              }
              if (_checked_in) {
                txt2 = `${this.$t('hotel.check_in')} ${data.defvalue.value.checked_in} ${this.$t(
                  'hotel.room'
                )}` // 正在入住XX间
              }
            }
          }
          return (
            <div style='min-height:90px;'>
              <div>{data.defvalue.text}</div>
              {txt1}
              <div>{txt2}</div>
              <div>{txt3}</div>
            </div>
          )
        }
      }
      return <div>{loop(parmas)}</div>
    },
    // 设置不可点击状态
    disabledDate(val) {
      val = val.getFullYear() +
      '-' +
      (val.getMonth() + 1 > 9 ? val.getMonth() + 1 : '0' + (val.getMonth() + 1)) +
      '-' +
      (val.getDate() > 9 ? val.getDate() : '0' + val.getDate())
      if (val < this.today) {
        return true
      } else {
        if (this.datas.data.date.substring(0, 7) != val.substring(0, 7)) return true
      }
      // let _month = this.datas.data.date
      //   ? new Date(this.datas.data.date).getMonth()
      //   : new Date().getMonth()
      // if (_month != new Date(val).getMonth()) {
      //   return true
      // }
    }
  }
}
</script>

<style>
.total {
  padding: 20px 10px 0px;
}
.total span {
  margin-right: 30px;
  margin-bottom: 10px;
  display: inline-block;
  font-size: 14px;
}
.total span a {
  color: #5cb3c8;
}
.box1 {
  display: flex;
}
.box_1 {
  width: 800px;
  min-width: 600px;
}
.rightbox {
  margin-left: 10px;
  width: 288px;
  border: 1px solid #e4e7ed;
}
.box_1 + .rightbox {
  padding-top: 44px;
}
.rightboxbottom > p {
  text-align: center;
  line-height: 44px;
  color: rgb(102, 102, 102);
}
.demo-ruleForm {
  width: 90%;
  margin: auto;
}
/* .box_1 .calendar .el-date-table-calendar td.current {
  background-color: #cddc39;
} */
.green {
  color: green;
}
.box_1 .calendar .el-date-table-calendar td.current .green {
  color: #fff;
}
</style>
